<template>
  <div class="div_table" :style="style">
    <ul
      class="ul_type flex"
      ref="refscroll"
      @mousedown="scrollDown"
      @mousemove="scrollMove"
      @mouseup="isDragging = false"
      @mouseleave="isDragging = false"
    >
      <li
        ref="scrollItem"
        v-for="(item, index) in tableData"
        :key="item.title"
        class="table-item cp_us"
        :class="nowTable.title == item.title ? 'item_color' : ''"
        @click="clickChange(item, index)"
      >
        <span>{{ item.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { nextTick, onMounted, onUnmounted, ref, defineEmits } from "vue";

const emit = defineEmits(["change"]);
const props = defineProps({
  tableData: {
    type: Array,
    default: () => [],
  },
  lable: {
    type: String,
    default: null,
  },
  style: {
    type: Object,
    default: () => ({}),
  },
});

// 当前选择的标签
let nowTable = ref({ title: "全部", icon: "\ue73b" });
// table切换控制
let tableStyle = ref({
  leftIcon: false,
  rightIcon: false,
});
let isDragging = ref(false);
let startX = 0;
let scrollLeftWidth = 0;
//---ref---
let refscroll = ref(null);
let scrollItem = ref(null);

if (props.lable) {
  let index = props.tableData.findIndex((item) => item.title === props.lable);

  if (index !== -1) {
    nowTable.value = props.tableData[index];
  }
}

//标签切换 10 9
function clickChange(item, index) {
  if (isDragging.value) return;
  if (nowTable.value.title === item.title) return;
  nowTable.value = item;
  scrollLeft(index);
  emit("change", item);
}
function scrollLeft(index) {
  let scrollWidth = refscroll.value.scrollWidth;
  let clientWidth = refscroll.value.clientWidth;
  if (scrollWidth <= clientWidth) return;
  let itemWidth = scrollItem.value[index].offsetWidth;
  let itemLeft = scrollItem.value[index].offsetLeft;
  refscroll.value.scroll({
    left: itemLeft - clientWidth / 2 + itemWidth / 2,
    behavior: "smooth", // 设置滚动行为为平滑
  });
}
// 拖拽移动
function scrollDown(e) {
  let scrollWidth = refscroll.value.scrollWidth;
  let clientWidth = refscroll.value.clientWidth;
  if (scrollWidth <= clientWidth) return;
  isDragging.value = true;
  startX = e.pageX - refscroll.value.offsetLeft;
  scrollLeftWidth = refscroll.value.scrollLeft;
}
function scrollMove(e) {
  if (!isDragging.value) return;
  e.preventDefault(); // 阻止默认行为，防止选中文本等
  let x = e.pageX - refscroll.value.offsetLeft;
  let walk = x - startX; // 计算移动的距离
  refscroll.value.scrollLeft = scrollLeftWidth - walk;
}
</script>

<style lang='scss' scoped>
.div_table {
  padding: 30px 60px;
  .ul_type {
    width: 100%;
    height: 100%;
    overflow-x: auto;
    position: relative;
    .table-item {
      white-space: nowrap;
      padding: 0px 24px;
      height: 50px;
      line-height: 50px;
      border-radius: 16px;
      font-size: 16px;
      margin-right: 14px;
      color: #62666d;
      background: #f6f7f8;
      transition: all $anim-time-fn-ease-out 0.25s;
      &:last-child {
        margin-right: 0px;
      }
    }
    .item_color {
      color: #ffffff;
      background: #000000;
    }
  }
}
@media screen and (max-width: 1280px) {
  .div_table {
    padding: 20px 30px;
  }
}
@media screen and (max-width: 768px) {
  .div_table {
    padding: 0.2rem 0.1rem;
    .ul_type {
      width: 100%;
      height: 100%;
      overflow-x: auto;
      position: relative;
      .table-item {
        white-space: nowrap;
        padding: 0rem 0.18rem;
        height: 0.4rem;
        line-height: 0.4rem;
        border-radius: 0.1rem;
        font-size: 0.14rem;
        margin-right: 0.12rem;
        color: #62666d;
        background: #f6f7f8;
        transition: all $anim-time-fn-ease-out 0.25s;
        &:last-child {
          margin-right: 0px;
        }
      }
      .item_color {
        color: #ffffff;
        background: #000000;
      }
    }
  }
}
</style>